<template>
    <v-dialog :model-value="dialog" @update:modelValue="onCerrarDialog" width="420">
        <v-card>

            <!-- Toolbar -->
            <v-toolbar color="primary-accent" density="compact">
            <v-toolbar-title class="text-center">
                <span class="titulo-dialogo raleway-light">
                Historial diario
                </span>
            </v-toolbar-title>
            </v-toolbar>

            <!-- Contenido -->
            <v-card-text>

                <!-- Loading -->
                <div
                    v-if="loading"
                    class="d-flex justify-center align-center"
                    style="height: 150px"
                >
                    <v-progress-circular
                    indeterminate
                    color="primary"
                    size="40"
                    />
                </div>

                <!-- Lista -->
                <v-list
                    v-else-if="fechas.length"
                    density="compact"
                    nav
                >
                    <v-list-item
                    v-for="fecha in fechas"
                    :key="fecha"
                    @click="seleccionarFecha(fecha)"
                    class="cursor-pointer"
                    >
                    <template #prepend>
                        <v-icon color="primary">mdi-calendar</v-icon>
                    </template>

                    <v-list-item-title>
                        {{ formatearFecha(fecha) }}
                    </v-list-item-title>

                    <v-list-item-subtitle>
                        {{ obtenerDiaSemana(fecha) }}
                    </v-list-item-subtitle>
                    </v-list-item>
                </v-list>

                <!-- Sin datos -->
                <div
                    v-else
                    class="text-center text-medium-emphasis"
                >
                    No hay historial disponible
                </div>

            </v-card-text>

            <!-- Acciones -->
            <v-card-actions class="justify-end">
            <v-btn color="error" variant="tonal" @click="$emit('cerrar')">
                Cerrar
            </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>

  <historial-turno
    v-if="abrirTurno"
    :fecha="fechaSeleccionada"
    @cerrar="abrirTurno = false"
  />
</template>

<script>
import historial from "@/services/historial";
import HistorialTurno from "./HistorialTurno.vue";

export default {
    emits: ['cerrar'],
    props: {
        dialog: Boolean
    },
    components: {
        HistorialTurno
    },
    data() {
        return {
        fechas: [],
        loading: true,
        abrirTurno: false,
        fechaSeleccionada: null
        };
    },
    async mounted() {
        try {
            this.loading = true;
            const res = await historial.obtenerFechas();
            this.fechas = res.data;
        } catch (error) {
            console.error("Error cargando fechas del historial", error);
        } finally {
            this.loading = false;
        }
    },
    methods: {
        seleccionarFecha(fecha) {
        this.fechaSeleccionada = fecha;
        this.abrirTurno = true;
        },
        obtenerDiaSemana(fecha) {
            const dias = [
            'Domingo',
            'Lunes',
            'Martes',
            'Miércoles',
            'Jueves',
            'Viernes',
            'Sábado'
            ];

            const d = new Date(fecha + 'T00:00:00');
            return dias[d.getDay()];
        },
        formatearFecha(fecha) {
            const [y, m, d] = fecha.split('-');
            return `${d}/${m}/${y}`;
        },
        onCerrarDialog(valor) {
            if (!valor) {
            this.$emit('cerrar');
            }
        },
    }
};
</script>